import React from 'react'
import { Heading, Style, Text } from 'components/library'
import { ModalPage } from './'

const HelpModal = props => (
  <ModalPage {...props}>
    <Style.Center>
      <Heading h1 html>Help</Heading>
      <Text large html style={{ marginTop: '4rem' }}>Test</Text>
    </Style.Center>
  </ModalPage>
)

export default HelpModal


// WEBPACK FOOTER //
// ./src/components/modals/HelpModal.js